<div class="help-dialog">
    <h1 mat-dialog-title>{{header}}</h1>
    <div mat-dialog-content>
    <p>{{text}}</p>
    </div>
    <div mat-dialog-actions>
    <button mat-button (click)="onNoClick()">close</button>
    <!-- <button mat-button [mat-dialog-close]="data.animal" cdkFocusInitial>Ok</button> -->
    </div>
</div>